import { render, staticRenderFns } from "./AgreeMent.vue?vue&type=template&id=90bc3218&scoped=true"
import script from "./AgreeMent.vue?vue&type=script&lang=js"
export * from "./AgreeMent.vue?vue&type=script&lang=js"
import style0 from "./AgreeMent.vue?vue&type=style&index=0&id=90bc3218&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bc3218",
  null
  
)

export default component.exports